import React from 'react';
import Styles from './styles.module.css';
import DefaultTitle from '../title';
import DefaultDesc from '../desc';

type DefaultInput1Input1Props = {
  title: string;
  value1: string;
  setValue1: (value1: string) => void;
  value2: string;
  setValue2: (value2: string) => void;
  place1: string;
  place2: string;
  length: number;
  desc?: string;
};

const DefaultInput1Input1: React.FC<DefaultInput1Input1Props> = ({ title, value1, setValue1, value2, setValue2, place1, place2, length, desc }) => {

  return (
    <>
    <DefaultTitle
      title={title}
    />
    <div className={Styles.input}>
      <input
        className={Styles.input_allowance}
        placeholder={place1}
        maxLength={length}
        value={value1 as string}
        onChange={(e) => setValue1(e.target.value)}
      />
      <div className={Styles.input_price}>
        <input
          className={Styles.input_price}
          placeholder={place2}
          maxLength={5}
          value={value2 as string}
          onChange={(e) => setValue2(e.target.value)}
        />
        <p>円</p>
      </div>
    </div>
    {desc && ( <DefaultDesc text={desc} /> )}
    </>
  );
}

export default DefaultInput1Input1;
